import React from "react";
import "./Main.css";
import Logo from "../components/Logo";
import Mobile from "../assets/Mobile.png";
import appstore from "../assets/appstore.png";
import googleplay from "../assets/google-play.png";
import { ReactComponent as Line } from "../assets/Vector.svg";

const Main = () => {
  return (
    <main className="main">
      <section className="main-content">
        <div className="main-items">
          <div className="main-left">
            <h1>
              <Logo />
            </h1>
            <p>
              Your Smart Spending Companion! Effortlessly track, manage, and
              understand your expenses with ease. Gain clarity on your finances,
              make informed decisions, and take control of your financial
              journey. Empower your financial growth with SpendScope!
            </p>
            <button>
              <a
                href="https://www.apple.com/in/app-store/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={appstore} alt="DownloadBtn" />
              </a>
            </button>
            <button>
              <a
                href="https://play.google.com/store/games?hl=en"
                target="_blank"
                rel="noreferrer"
              >
                <img src={googleplay} alt="DownloadBtn" />
              </a>
            </button>
          </div>
        </div>
        <div className="main-items main-right">
          <img src={Mobile} alt="MobileImage" className="mobile-img" />
          <Line className="mobile-view-line" />
        </div>
        <h1 className="mobile-view-heading">
          <Logo />
        </h1>
      </section>
      <Line className="desktop-view-line" />
    </main>
  );
};

export default Main;
